// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"871b0a2c","951":"4e87801d"}[chunkId] + ".chunk.css";
};